import styles from "./TokensDisplay.module.css";
import { useEffect } from "react";
import TokenCard from "../TokenCard/TokenCard";
import TopMoversCard from "../TopMovers/TopMoversCard";
import { uniDefaultTokenList } from "../../../../../data/tokens";
const TokensDisplay = () => {

  
  const TopMoversDisplay = uniDefaultTokenList.tokens.map((token, idx) => (
    <TopMoversCard image={token.logoURI} name={token.name} symbol={token.symbol} idx={ idx}/>
))
  const AllTokensDisplay = uniDefaultTokenList.tokens.map((token, idx) => (
    <TokenCard image={token.logoURI} name={token.name} symbol={token.symbol} idx={ idx}/>
))


  const TopTokensHeader = (
    <div className={styles.top_tokens_header}>
      <span className={styles.token_number}>#</span>
      <span className={styles.title_name}>Name</span>
      <span className={styles.title_price}>Price</span>
      <span className={styles.title_price_change}>Price Change</span>
      <span className={styles.title_volume}>Volume 24H</span>
      <span className={styles.title_tvl}>TVL ^</span>
    </div>
  );

  const watchList = (
    <div>
      <span>Your Watchlist</span>
      <div className={styles.watchlist_container}>
        <div className={styles.watchlist_placeholder}>
          Tokens on you watchlist will appear here
        </div>
      </div>
    </div>
  );


  const topMovers = (
    <div className={styles.top_movers_container}>
    <div className={styles.top_movers_content}>
        <span className={styles.top_movers_title}>Top Movers</span>
        <div className={styles.top_movers_content_container}>
            <div className={styles.top_movers_content_container_content} id="flavoursContainer">
                {TopMoversDisplay}
            </div>
        </div>
    </div>
</div>
  )

  return (
    <div className={styles.crypto_page}>
      <div className={styles.crypto_container}>
        <div className={styles.crypto_content}>
          {watchList}
    {topMovers}
          <span>All Tokens</span>
          <div className={styles.top_tokens_container}>
            <div className={styles.top_tokens_content}>
              {TopTokensHeader}
              <span className={styles.advisor}></span>
              {AllTokensDisplay}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokensDisplay;
